import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import plus from 'assets/icons/plus.svg'

type MoreInfoProps = {
  onClick?: () => void
  className?: string
}

export const MoreInfo = ({ onClick, className }: MoreInfoProps) => {
  return (
    <Box
      className={
        className
          ? className
          : 'text-blue-bb font-bb-bold text-sm flex gap-1 items-center mt-5 cursor-pointer justify-center'
      }
      onClick={onClick}
    >
      <img src={plus} alt="ícone de adição" />

      <Typography className="font-bold text-[14px]">{'Informações'}</Typography>
    </Box>
  )
}
